export default "__VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__";